import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotStore } from 'pages/chatbot'

const ChatbotContext = createContext<ChatbotStore | null>(null)

export const useChatbotContext = () => {
  const context = useContext(ChatbotContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ChatbotContextProvider')

  return context
}

export const ChatbotProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ChatbotStore(entities), [])

  useEffect(() => store.dispose, [])

  return <ChatbotContext.Provider value={store}>{children}</ChatbotContext.Provider>
}
